//========================= slider-component draggable scroll for desktop (generated with AI)
document.addEventListener('DOMContentLoaded', () => {
  const dragSliderComponents = document.querySelectorAll('slider-component.draggable-scroll');
  dragSliderComponents.forEach((sliderComponent) => {
    initSliderComponentDraggableScroll(sliderComponent);
  });
});
function initSliderComponentDraggableScroll(sliderComponent) {
  if (!sliderComponent) return;

  const sliderElement = sliderComponent.querySelector('ul.slider--desktop'); // The UL element
  // Attempt to get instance data if needed (adjust based on theme)
  const sliderInstance = sliderComponent.sliderController || sliderComponent;

  if (!sliderElement) return;

  // --- State Variables ---
  let isDown = false;
  let isDragging = false;
  let startX = 0;
  let scrollLeftStart = 0; // scrollLeft value when drag started
  let itemOffset = 0; // Calculated distance between items
  let rafId = null; // For requestAnimationFrame
  let immediateScrollLeft = 0; // Store target scrollLeft for RAF

  function calculateItemOffset() {
    const items = sliderElement.querySelectorAll(':scope > li.grid__item');
    let firstVisibleItem = null;
    let secondVisibleItem = null;
    for (let item of items) {
      if (item.offsetWidth > 0) { // Check if item is actually visible/rendered
        if (firstVisibleItem === null) {
          firstVisibleItem = item;
        } else {
          secondVisibleItem = item;
          break; // Found the first two visible items
        }
      }
    }

    if (secondVisibleItem) {
      return secondVisibleItem.offsetLeft - firstVisibleItem.offsetLeft;
    } else if (firstVisibleItem) {
      return firstVisibleItem.offsetWidth; // Fallback if only one item
    }
    return sliderElement.clientWidth; // Fallback if no items or calculation fails
  }

  // Initial calculation
  itemOffset = calculateItemOffset();
  // Recalculate on resize (debounced)
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => { clearTimeout(timeout); func(...args); };
      clearTimeout(timeout); timeout = setTimeout(later, wait);
    };
  };
  const debouncedRecalculateOffset = debounce(() => { itemOffset = calculateItemOffset(); }, 250);
  const resizeObserver = new ResizeObserver(debouncedRecalculateOffset);
  resizeObserver.observe(sliderElement);


  // --- Event Listeners ---
  sliderElement.addEventListener('mousedown', (e) => {
    // Prevent drag start on interactive elements if desired
    // if (e.target.closest('button, a[href]')) return;

    isDown = true;
    isDragging = false;
    startX = e.pageX - sliderElement.offsetLeft; // Adjust startX relative to the element
    scrollLeftStart = sliderElement.scrollLeft; // Store scroll position at start
    immediateScrollLeft = scrollLeftStart; // Initialize immediate target
    sliderElement.classList.add('grabbing'); // Sets cursor and scroll-behavior: auto
    if (rafId) cancelAnimationFrame(rafId); // Cancel pending frames
    rafId = null;
    // Do NOT preventDefault here - allows normal clicks if no drag occurs
  });

  sliderElement.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    // Prevent default text selection *only* if dragging starts
    e.preventDefault();

    const x = e.pageX - sliderElement.offsetLeft;
    const walk = (x - startX); // How far mouse moved frommousedown point

    // Check drag threshold only once
    if (!isDragging && Math.abs(walk) > 5) {
      isDragging = true;
    }

    if (isDragging) {
      // Calculate target scroll position
      immediateScrollLeft = scrollLeftStart - walk; // Scroll left moves opposite to mouse drag

      // Schedule update within animation frame for smoothness
      if (!rafId) {
        rafId = requestAnimationFrame(() => {
          sliderElement.scrollLeft = immediateScrollLeft;
          rafId = null; // Reset RAF ID
          // No heavy updates here
        });
      }
    }
  });

  function finishDrag() {
    if (!isDown) return; // Ensure executed only once
    isDown = false;
    sliderElement.classList.remove('grabbing'); // Restore smooth scroll behavior
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; } // Clean up animation frame

    const wasDragging = isDragging; // Capture state before reset

    // Delay reset for click prevention
    setTimeout(() => { isDragging = false; }, 0);

    if (wasDragging) {
      // Calculate where to snap smoothly
      itemOffset = calculateItemOffset(); // Ensure offset is up-to-date
      if (itemOffset > 0) {
        const currentScroll = sliderElement.scrollLeft; // Use final scroll position
        const targetIndex = Math.round(currentScroll / itemOffset);
        let targetScrollLeft = targetIndex * itemOffset;

        // *** CLAMPING ***: Ensure target is within valid scroll bounds
        const maxScrollLeft = sliderElement.scrollWidth - sliderElement.clientWidth;
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

        // Use smooth scroll to snap to the calculated, clamped position
        sliderElement.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth' // Native smooth scroll for snapping
        });

        // NOTE: The original SliderComponent's 'scroll' listener should automatically
        // update buttons/pagination during the smooth scroll animation.
      }
    }
    // Update UI logic (button states, pagination) should ideally still be handled
    // by the original theme's SliderComponent listening to 'scroll' events.
    // If not, you might need to manually trigger its update method here or after scroll ends.
  }

  sliderElement.addEventListener('mouseup', finishDrag);
  sliderElement.addEventListener('mouseleave', finishDrag);

  // Click prevention (Capture phase)
  sliderElement.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // --- Mobile Touch Scroll ---
  // By default, with overflow-x: auto and NO touch event listeners calling preventDefault,
  // native touch scrolling should work. Ensure no other scripts or CSS
  // (like touch-action: none) are interfering.
  // We are *not* adding touchstart/touchmove/touchend listeners here to preserve native behavior.
}

// scroll buttons
(function(){
  let scrollBtns = document.querySelectorAll('a[href^="#"]');
  if (scrollBtns.length) {
    scrollBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        let selector = e.target.getAttribute('href');
        if (selector == '#') return;
        let target = document.querySelector(selector);
        if(!target) return;
        e.preventDefault();
        let top = window.pageYOffset + target.getBoundingClientRect().top - 50;
        window.scroll({
          top: top, 
          left: 0, 
          behavior: 'smooth' 
        });
      });
    });
  }

  // same for dynamically added buttons, e.g. loox stars ratring
  document.addEventListener('click', function(e) {
    const link = event.target.closest('a[href^="#"]');
    if (link) {
      let selector = link.getAttribute('href');
      // debugger;
      if (selector == '#') return;
      let target = document.querySelector(selector);
      if(!target) return;
      e.preventDefault();
      let top = window.pageYOffset + target.getBoundingClientRect().top - 50;
      window.scroll({
        top: top, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  });
})();

// animated accordion
document.addEventListener('click', function(event) {
  if (event.target.matches('.animated-accordion summary') 
      || event.target.matches('.animated-accordion summary h3')
      || event.target.matches('.animated-accordion summary svg')
  ) {
    event.preventDefault();
    const item = event.target.closest('.animated-accordion');
    const panel = item.querySelector('.animated-accordion__panel');
    const isOpen = item.classList.contains('active');
    if (isOpen) {
      item.classList.remove('active');
      panel.style.maxHeight = 0;
    } else {
      item.classList.add('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
});
